import script from "./ChooseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseCard.vue?vue&type=script&setup=true&lang=js"

import "./ChooseCard.vue?vue&type=style&index=0&id=67abeaa4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67abeaa4"]])

export default __exports__